import { render, staticRenderFns } from "./insuranceclass.vue?vue&type=template&id=53742164&scoped=true&"
import script from "./insuranceclass.vue?vue&type=script&lang=js&"
export * from "./insuranceclass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53742164",
  null
  
)

export default component.exports